/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Mailing_ContactForm } from '../models/Mailing_ContactForm';
import type { Mailing_ShoppingListEmail } from '../models/Mailing_ShoppingListEmail';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MailingService {
    /**
     * Send contact form.
     * Email filled contact form to Globus.
     * @returns void
     * @throws ApiError
     */
    public static sendContactForm({
        formData,
        apiVersion = 1,
    }: {
        formData: Mailing_ContactForm,
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/mailing/sendContactForm',
            path: {
                'apiVersion': apiVersion,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Validation error.`,
            },
        });
    }
    /**
     * Send shopping list email.
     * Email shopping list computed on frontend. Image asset URLs are provided by backend.
     * @returns void
     * @throws ApiError
     */
    public static sendShoppingList({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: Mailing_ShoppingListEmail,
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/mailing/sendShoppingList',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
            },
        });
    }
}
